import { FormEvent, useState } from 'react'
import { Wordmark } from '../components/ui/Wordmark'
import { useWaitlistSignup, useWaitlistCount } from '../hooks/useWaitlist'
import { ApiError } from '../lib/api'

export default function ComingSoonPage() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const signup = useWaitlistSignup()
  const { data: countData } = useWaitlistCount()
  const count = countData?.data?.count ?? 0

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    if (!email.trim()) return
    signup.mutate(email.trim(), {
      onSuccess: () => setSubmitted(true),
    })
  }

  const serverError = signup.error instanceof ApiError ? signup.error.message : null

  return (
    <div className="min-h-screen bg-bg flex flex-col items-center px-6 pt-[60px] pb-20">
      <Wordmark size={26} />

      <div className="flex-1 flex flex-col items-center justify-center w-full max-w-[520px]">
        <h1 className="serif text-[52px] m-0 mb-5 text-center leading-[1.1] tracking-[-0.025em]">
          Fellowship events,{' '}
          <span className="serif-i text-primary">across the church</span>
        </h1>

        <p className="text-base text-ink-2 text-center leading-[1.65] m-0 mb-10 max-w-[420px]">
          Get notified when new events are posted near you — potlucks, hikes, Bible studies, and more from churches in your area.
        </p>

        {submitted ? (
          <div className="flex flex-col items-center gap-2.5 px-9 py-7 rounded-[20px] bg-surface border border-line-soft">
            <div className="w-12 h-12 rounded-full bg-primary text-on-primary flex items-center justify-center text-[22px] mb-1">
              ✓
            </div>
            <div className="serif text-[22px]">You're on the list!</div>
            <p className="text-[13px] text-ink-2 text-center m-0 leading-[1.5]">
              We'll send you a note when Fellowship opens its doors.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} noValidate className="w-full max-w-[420px]">
            <div className="flex gap-2.5 bg-surface border border-line-soft rounded-full px-5 py-1.5 shadow-[0_2px_12px_rgba(60,40,10,0.06)]">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                aria-label="Email address"
                required
                className="flex-1 border-0 bg-transparent outline-none font-medium text-[15px] text-ink min-w-0"
              />
              <button
                type="submit"
                disabled={signup.isPending}
                className="h-11 px-[22px] rounded-full border-0 bg-primary text-on-primary text-sm font-semibold cursor-pointer shrink-0 whitespace-nowrap disabled:bg-muted disabled:cursor-not-allowed"
              >
                {signup.isPending ? 'Joining…' : 'Notify me'}
              </button>
            </div>

            {serverError && (
              <p role="alert" className="text-xs text-[#A33A2A] mt-2 ml-5">
                {serverError}
              </p>
            )}

            {count > 0 && (
              <p className="text-xs text-muted text-center mt-3.5">
                {count} {count === 1 ? 'person' : 'people'} already on the waitlist
              </p>
            )}
          </form>
        )}
      </div>

      <p className="text-xs text-muted m-0">
        No spam, ever. Unsubscribe any time.
      </p>
    </div>
  )
}
